// extracted by mini-css-extract-plugin
export var aiStarIcon = "_sq-2";
export var container = "_sq-4";
export var dismissButton = "_sq-3";
export var hasPaddingBottom = "_sq-6";
export var last = "_sq-e";
export var scrollbarThumb = "_sq-c";
export var scrollbarTrack = "_sq-b";
export var selected = "_sq-9";
export var spin = "_sq-1";
export var spinning = "_sq-0";
export var suggestionItem = "_sq-d";
export var suggestionsPanel = "_sq-5";
export var tonePill = "_sq-8";
export var tonesContainer = "_sq-7";
export var unselected = "_sq-a";